import { AmendmentType } from './../interfaces/amendment.interface';

export const amendmentTypes: AmendmentType[] = [
  {
    key: 'company-name',
    title: 'Amend Company Name',
    description: 'Update company name, registered address or business activity',
    icon: 'business',
    disabled: false,
  },
  {
    key: 'add-branch',
    title: 'Add New Branch',
    description: 'Register a new company branch',
    icon: 'account_tree',
    disabled: false,
  },
  {
    key: 'close-company',
    title: 'Liquidation',
    description: 'Request company dissolution',
    icon: 'block',
    disabled: false,
  },
  {
    key: 'declare-dormant',
    title: 'Declare Dormant',
    description: 'Mark company as inactive',
    icon: 'pause_circle',
    disabled: false,
  },
  {
    key: 'amalgamation',
    title: 'Amalgamation',
    description: 'Merge companies into one entity',
    icon: 'merge',
    disabled: false,
  },
  {
    key: 'amend-Ownership',
    title: 'Amend Ownership and Control',
    description: 'Update share ownership or director information',
    icon: 'warning_amber',
    disabled: false,
  },
  {
    key: 'transfer-share',
    title: 'Transfer Shares',
    description: 'Transfer shares from one shareholder to another',
    icon: 'currency_exchange',
    disabled: false,
  },
  {
    key: 'cessation-of-dormancy',
    title: 'Cessation of Dormancy',
    description: 'Mark company as active',
    icon: 'play_circle',
    disabled: false,
  },
  {
    key: 'other',
    title: 'Other',
    description: 'Amend other company information',
    icon: 'warning_amber',
    disabled: false,
  },
];

export enum AmendmentTypes {
  COMPANY_NAME = 'company-name',
  ADD_BRANCH = 'add-branch',
  CLOSE_COMPANY = 'close-company',
  DECLARE_DORMANT = 'declare-dormant',
  AMALGAMATION = 'amalgamation',
  AMEND_OWNERSHIP = 'amend-Ownership',
  TRANSFER_SHARE = 'transfer-share',
  CESSATION_OF_DORMANCY = 'cessation-of-dormancy',
}

export enum AmendmentTypeEnum {
  COMPANY_NAME_AMENDMENT = 'COMPANY_NAME_AMENDMENT',
  COMPANY_ADD_NEW_BRANCH_AMENDMENT = 'COMPANY_ADD_NEW_BRANCH_AMENDMENT',
  COMPANY_CLOSURE_AMENDMENT = 'COMPANY_CLOSURE_AMENDMENT',
  COMPANY_DORMANCY_AMENDMENT = 'COMPANY_DORMANCY_AMENDMENT',
  COMPANY_CESSATION_OF_DORMANT_AMENDMENT = 'COMPANY_CESSATION_OF_DORMANT_AMENDMENT',
  DECLARATION_TO_BE_DORMANT = 'DECLARATION_TO_BE_DORMANT',
  COMPANY_AMALGAMATION_AMENDMENT = 'COMPANY_AMALGAMATION_AMENDMENT',
  COMPANY_SHAREHOLDERS_AGREEMENT_AMENDMENT = 'COMPANY_SHAREHOLDERS_AGREEMENT_AMENDMENT',
  COMPANY_AMENDMENT_OWNERSHIP = 'COMPANY_AMENDMENT_OWNERSHIP',
  OWNERSHIP_CONTROL_AMENDMENT = 'OWNERSHIP_CONTROL_AMENDMENT',
  COMPANY_TRANSFER_SHARE_AMENDMENT = 'COMPANY_TRANSFER_SHARE_AMENDMENT',
  AMEND_DIRECTORS = 'AMEND_DIRECTORS',
  AMEND_BENEFICIAL_OWNERS = 'AMEND_BENEFICIAL_OWNERS',
  COMPANY_OWNERSHIP_AMENDMENT = 'COMPANY_OWNERSHIP_AMENDMENT',
  OTHER_AMENDMENT = 'OTHER_AMENDMENT',
}

export enum AmalgmationTypeEnum {
  COMPANY_AMALGAMATION_ABSORPTION = 'COMPANY_AMALGAMATION_ABSORPTION',
  COMPANY_AMALGAMATION_CONSOLIDATION = 'COMPANY_AMALGAMATION_CONSOLIDATION',

}
